// all routes
import React, { useEffect } from "react";
import Routes from "./routes/Routes";
import { useRedux } from "./hooks";
import { loginUser } from "./redux/actions";
// helpers
import { configureFakeBackend } from "./helpers";
import { ModalProvider } from "./context/ModalContext";
import AuthGate from "./auth/AuthGate";

// For Default import Theme.scss
import "./assets/scss/Theme.scss";

const App = () => {
  configureFakeBackend();
  return (
    <ModalProvider>
      <AuthGate>
        <Routes />
      </AuthGate>
    </ModalProvider>
  );
};

export default App;
